module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.setDropdownFromClick),
      expression: "setDropdownFromClick"
    }],
    ref: "role_child",
    staticClass: "role-change",
    class: {
      'role-change--active': _vm.isDropDown
    }
  }, [(_vm.isDropDown) ? _c('div', {
    staticClass: "role-change__dropdown__container"
  }, [_c('transition', {
    attrs: {
      "name": "d-dropdown"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "role-change__dropdown"
  }, [_c('ul', _vm._l((_vm.roles), function(role) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setRole(role)
        }
      }
    }, [_vm._v("\n            " + _vm._s(role.v_title) + "\n          ")])
  }), 0)]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38f50666!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Permissions/PermissionsUserChange.vue
// module id = 1535
// module chunks = 1